import axios from 'axios';
import { config } from "./ConfigService";

class ProviderService {

    getProviders(taxId) {
        //return axios.get(`${config.API_URL}/provider/list/${taxId}`)
        return axios.get(`${config.API_URL}/provider/list/${taxId}`)
    }

    getProviderPhysician(prvId) {
        return axios.get(`${config.API_URL}/provider/Phys/${prvId}`)
    }
    getProviderPhysicianSpecialties(prvId) {
        return axios.get(`${config.API_URL}/provider/Phys/Spec/${prvId}`)
    }
    getProviderPhysicianLocations(prvId) {
        return axios.get(`${config.API_URL}/provider/Phys/Loc/${prvId}`)
    }
    getAddressById(addrId) {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/addresses/address?addressId=946299
        return axios.get(`${config.API_URL}/provider/addresses/address?addressId=${addrId}`)
    }
    getProviderLicenses(prvId) {
        return axios.get(`${config.API_URL}/provider/Phys/Lic/${prvId}`)
    }

    getProviderPhysicianLicenses(prvId) {
        return axios.get(`${config.API_URL}/provider/Phys/Lic/${prvId}`)

    }
    getProviderFacility(prvId) {
        return axios.get(`${config.API_URL}/provider/facility/${prvId}`)
    }
    getProviderFacilityLocations(prvId) {
        return axios.get(`${config.API_URL}/provider/facility/Loc/${prvId}`)
    }
    getFacilityLicenses(prvId) {
        return axios.get(`${config.API_URL}/provider/Fac/Lic/${prvId}`)
    }
    getProviderTypes() {
        return axios.get(`${config.API_URL}/provider/participations/prvtype?prvType=P&planId=19`)
    }
    getSpecialtiesByProviderType(prvId, providerTypeId) {
        //return axios.get(`${config.API_URL}/provider/specialties/parrlist?prvId=2665585&parrId=2`)
        return axios.get(`${config.API_URL}/provider/specialties/parrlist?prvId=${prvId}&parrId=${providerTypeId}`)
    }

    getLanguages(prvId) {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/physician-languages/provider-list?prvId=24489
        return axios.get(`${config.API_URL}/provider/physician-languages/provider-list?prvId=${prvId}`)
    }

    getDegrees(prvId) {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/physician-degrees/provider-list?prvId=24489
        return axios.get(`${config.API_URL}/provider/physician-degrees/provider-list?prvId=${prvId}`)
    }

    getValidLicenseTypeForPrvType(prvType) {
        return axios.get(`${config.API_URL}/provider/license-types/prvtype?prvType=${prvType}`)
        //return axios.get(`${config.API_URL}/provider/license-types/prvtype?prvType=P`)
    }

    getValidLicenseStatus() {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/license-statuses
        return axios.get(`${config.API_URL}/provider/license-statuses`)
    }

    getStatesAndTerritories() {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/state-refs
        return axios.get(`${config.API_URL}/provider/state-refs`)

    }
    getFocusAreasForProvider() {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/focus-refs
        return axios.get(`${config.API_URL}/provider/focus-refs`)
    }

    getAddressForId(addressId) {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/addresses/address?addressId=946299
        return axios.get(`${config.API_URL}/provider/addresses/address?addressId=${addressId}`)
    }

    getCountiesForState(stateId) {
        //https://wcpp.qa.enlyte360.com/wcpp-services/provider/counties/state?state=FL
        return axios.get(`${config.API_URL}/provider/counties/state?state=${stateId}`);
    }

    //to get facility specialities
    getSpecialtiesForFacility(prvId, locId) {
        return axios.get(`${config.API_URL}/provider/specialties/facilityLocList?prvId=${prvId}&facLocId=${locId}`)
    }

    //to get facility languages
    getLanguagesForFacility(prvId, locId) {
        return axios.get(`${config.API_URL}/provider/facility-languages/language-list?prvId=${prvId}&facLocId=${locId}`)
    }

    //to get FacilityServices
    getServicesForFacility(prvId, locId) {
        return axios.get(`${config.API_URL}/provider/facility-services/service-list?prvId=${prvId}&facLocId=${locId}`)
    }

    getAllServicesForFacility() {
        return axios.get(`${config.API_URL}/provider/facility/service/reflist`)
    }
    getAllSpecialtyForFacility() {
        return axios.get(`${config.API_URL}/provider/Specialty/reflist`)
    }


    submitProviderInfoChange(requestObject) {
        const {
            providerIdentificationInfo,
            generalInfoChange,
            specialtyChanges,
            locationChanges,
            licenseChanges,
            providerStatusUpdate
        } = requestObject;

        const payload = {
            providerIdentificationInfo
        };
        if (generalInfoChange) payload.generalInfoChange = generalInfoChange;
        if (specialtyChanges) payload.specialtyChanges = specialtyChanges;
        if (locationChanges) payload.locationChanges = locationChanges;
        if (licenseChanges) payload.licenseChanges = licenseChanges;
        if (providerStatusUpdate) payload.providerStatusUpdate = providerStatusUpdate;
        return axios.post(`${config.API_URL}/provider/provider-info-change`, payload);
    }



    submitFacilityInfoChange(requestObject) {
        const {
            providerIdentificationInfo,
            generalInfoChange,
            locationChanges,
            licenseChanges,

        } = requestObject;

        const payload = {
            providerIdentificationInfo
        };
        if (generalInfoChange) payload.generalInfoChange = generalInfoChange;
        if (locationChanges) payload.locationChanges = locationChanges;
        if (licenseChanges) payload.licenseChanges = licenseChanges;
        return axios.post(`${config.API_URL}/provider/provider-info-change`, payload);
    }

}


export default new ProviderService();
